import * as React from 'react';
import { Alert } from 'reactstrap';

export interface FilterEditRequiredValidationProps {
	messageOverride: string;
}

class FilterEditRequiredValidation extends React.PureComponent<FilterEditRequiredValidationProps> {
	public static defaultProps = {
		messageOverride: 'Search field is required',
	};

	public render() {
		return <Alert color="danger">{this.props.messageOverride}</Alert>;
	}
}

export default FilterEditRequiredValidation;
